export default __webpack_public_path__ + "static/media/warning.fa1f1039.svg";